var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"table-router-link",attrs:{"to":{ name: 'Card', params: { id: _vm.row.id }, query: _vm.filterParams }}},[_vm._v(" "+_vm._s(_vm.row.user.full_name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }